// extracted by mini-css-extract-plugin
export default {"reportHealthRiskDetails":"MarkerClusterComponent_reportHealthRiskDetails__4XXtH","popup":"MarkerClusterComponent_popup__nEmlr"};